import React from 'react';
import { Grid, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';

import { PropertyTextInput } from '@paragon/client-tools';
import { EstimateInfo } from '@paragon/contract-library';
import { NumericField } from '@paragon/material';

interface AuxiliaryEstimateInfoFieldsProps {
  readonly estimateInfo: EstimateInfo;
  readonly setEstimateInfo: (auxiliaryEstimateInfo: EstimateInfo) => void;
}

export function AuxiliaryEstimateInfoFields({ estimateInfo, setEstimateInfo }: AuxiliaryEstimateInfoFieldsProps) {
  return (
    <>
      <Typography variant="h5">Additional Estimate Info</Typography>
      <Grid container spacing={1}>
        <Grid size={8}>
          <NumericField
            label="Labor cost"
            startAdornment="$"
            endAdornment={`/${estimateInfo.laborCostUnit}`}
            min={0}
            value={estimateInfo.laborCostPerUnit}
            onSubmit={(laborCostPerUnit) => void setEstimateInfo({ ...estimateInfo, laborCostPerUnit })}
          />
        </Grid>
        <Grid size={4}>
          <ToggleButtonGroup
            value={estimateInfo.laborCostUnit}
            size="small"
            exclusive
            onChange={(_, laborCostUnit) => {
              if (laborCostUnit == null) return;
              setEstimateInfo({ ...estimateInfo, laborCostUnit });
            }}
            sx={{ mt: 2 }}
          >
            <ToggleButton value="BF">BF</ToggleButton>
            <ToggleButton value="LF">LF</ToggleButton>
          </ToggleButtonGroup>
        </Grid>
        <Grid size={12}>
          <NumericField
            label="Freight cost per mile"
            min={0}
            startAdornment="$"
            endAdornment="/mile"
            value={estimateInfo.freightCostPerMile}
            onSubmit={(freightCostPerMile) => void setEstimateInfo({ ...estimateInfo, freightCostPerMile })}
          />
        </Grid>
        <Grid size={12}>
          <NumericField
            label="Number of miles (one way)"
            min={0}
            endAdornment="miles"
            value={estimateInfo.numberOfMilesOneWay}
            onSubmit={(numberOfMilesOneWay) => void setEstimateInfo({ ...estimateInfo, numberOfMilesOneWay })}
          />
        </Grid>
        <Grid size={12}>
          <NumericField
            label="Number of truckloads"
            min={0}
            value={estimateInfo.numberOfTruckloads}
            onSubmit={(numberOfTruckloads) => void setEstimateInfo({ ...estimateInfo, numberOfTruckloads })}
          />
        </Grid>
        <Grid size={12}>
          <NumericField
            label="Overhead"
            startAdornment="$"
            min={0}
            value={estimateInfo.overhead}
            onSubmit={(overhead) => void setEstimateInfo({ ...estimateInfo, overhead })}
          />
        </Grid>
        <Grid size={12}>
          <NumericField
            label="Margin percentage"
            endAdornment="%"
            min={0}
            value={estimateInfo.marginPercentage}
            onSubmit={(marginPercentage) => void setEstimateInfo({ ...estimateInfo, marginPercentage })}
          />
        </Grid>
        <Grid size={12}>
          <NumericField
            label="Total Square Feet"
            endAdornment="sq. ft."
            min={0}
            value={estimateInfo.totalSquareFeet}
            onSubmit={(totalSquareFeet) => void setEstimateInfo({ ...estimateInfo, totalSquareFeet })}
          />
        </Grid>
        <Grid size={12}>
          <PropertyTextInput
            property="Notes"
            multiline
            fullWidth
            value={estimateInfo.notes ?? ''}
            submit={(notes) => void setEstimateInfo({ ...estimateInfo, notes })}
          />
        </Grid>
      </Grid>
    </>
  );
}
